import { render, staticRenderFns } from "./ButtonToolbarJustify.vue?vue&type=template&id=0b04f1d4&"
import script from "./ButtonToolbarJustify.vue?vue&type=script&lang=js&"
export * from "./ButtonToolbarJustify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports